<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34375 2.34375C1.91228 2.34375 1.5625 2.69353 1.5625 3.125C1.5625 3.55647 1.91228 3.90625 2.34375 3.90625H3.125V14.8438C3.125 16.5696 4.52411 17.9687 6.25 17.9687H7.50982L6.29009 21.6279C6.15365 22.0373 6.37487 22.4797 6.7842 22.6162C7.19353 22.7526 7.63596 22.5314 7.77241 22.1221L8.11518 21.0937H16.8848L17.2276 22.1221C17.364 22.5314 17.8065 22.7526 18.2158 22.6162C18.6251 22.4797 18.8464 22.0373 18.7099 21.6279L17.4902 17.9687H18.75C20.4759 17.9687 21.875 16.5696 21.875 14.8438V3.90625H22.6562C23.0877 3.90625 23.4375 3.55647 23.4375 3.125C23.4375 2.69353 23.0877 2.34375 22.6562 2.34375H2.34375ZM9.15684 17.9687H15.8432L16.364 19.5312H8.63601L9.15684 17.9687ZM17.5787 8.59862C17.9522 8.38257 18.0798 7.90466 17.8638 7.53117C17.6477 7.15769 17.1698 7.03006 16.7963 7.24611C15.3726 8.06967 14.1163 9.14969 13.0903 10.4231L11.4899 8.82266C11.1848 8.51756 10.6902 8.51756 10.3851 8.82266L7.26007 11.9477C6.95498 12.2528 6.95498 12.7474 7.26007 13.0525C7.56517 13.3576 8.05983 13.3576 8.36493 13.0525L10.9375 10.4799L12.6221 12.1646C12.7857 12.3281 13.0132 12.4108 13.2436 12.3904C13.4739 12.3699 13.6834 12.2485 13.8156 12.0588C14.7989 10.6476 16.0848 9.46279 17.5787 8.59862Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgTeacher',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>